// Filter Types
export const FILTER_TYPE_BOOLEAN = 'FILTER_TYPE_BOOLEAN';
export const FILTER_TYPE_LIST = 'FILTER_TYPE_LIST';
export const FILTER_TYPE_STRING = 'FILTER_TYPE_STRING';

export const FILTER_KEYS = {
  is_landscape: {
    label: 'Landscape',
    defaultValue: false,
    filterType: FILTER_TYPE_BOOLEAN,
    existenceCheck: value => !!value,
  },
  is_portrait: {
    label: 'Portrait',
    defaultValue: false,
    filterType: FILTER_TYPE_BOOLEAN,
    existenceCheck: value => !!value,
  },
  featured_artist: {
    label: 'Designs by Featured Artists',
    defaultValue: false,
    filterType: FILTER_TYPE_BOOLEAN,
    existenceCheck: value => !!value,
  },
  has_foil: {
    label: 'Foil Designs',
    defaultValue: false,
    filterType: FILTER_TYPE_BOOLEAN,
    existenceCheck: value => !!value,
  },
  has_custom_photo: {
    label: 'Designs with Photos',
    defaultValue: false,
    filterType: FILTER_TYPE_BOOLEAN,
    existenceCheck: value => !!value,
  },
  has_no_custom_photo: {
    label: 'No Photos',
    defaultValue: false,
    filterType: FILTER_TYPE_BOOLEAN,
    existenceCheck: value => !!value,
  },
  has_magnet: {
    label: 'Designs for Magnets',
    defaultValue: false,
    filterType: FILTER_TYPE_BOOLEAN,
    existenceCheck: value => !!value,
  },
  is_vow_renewal: {
    label: 'Reception Only Designs',
    defaultValue: false,
    filterType: FILTER_TYPE_BOOLEAN,
    existenceCheck: value => !!value,
  },
  is_letterpress: {
    label: 'Letterpress Designs',
    defaultValue: false,
    filterType: FILTER_TYPE_BOOLEAN,
    existenceCheck: value => !!value,
  },
  multiColor: {
    label: '',
    defaultValue: null,
    filterType: FILTER_TYPE_LIST,
    existenceCheck: value => value.length > 0,
  },
  motifs: {
    label: '',
    defaultValue: [],
    filterType: FILTER_TYPE_LIST,
    existenceCheck: value => value.length > 0,
  },
};

export const MORE_FILTER_LIST_MOBILE = [
  'has_magnet',
  'has_custom_photo',
  'has_no_custom_photo',
  'has_foil',
  'is_letterpress',
  'is_vow_renewal',
  'is_landscape',
  'is_portrait',
  'featured_artist',
];

export const MORE_FILTER_LIST_DESKTOP = ['is_landscape', 'is_portrait', 'featured_artist'];



// WEBPACK FOOTER //
// ./src/cards/components/CardListing/CardListingRedesign/CardListingFilter/constants.js